import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const initStateSubscriptionAction = {
  subscriptionAction: { data: null, loading: false, error: null },
};

export const subscriptionAction = createAsyncThunk(
  "payment/subscriptionAction",
  async ({ subscriptionId, action }, { rejectWithValue, fulfillWithValue }) => {
    const token = localStorage.getItem("token");
    if (!token) return rejectWithValue({ error: "Необходима авторизация" });

    return await axios
      .post(
        `${process.env.REACT_APP_SERVER_API}/payments/apipay/subscriptions/${subscriptionId}/${action}/`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      )
      .then((res) => fulfillWithValue(res.data))
      .catch((res) =>
        rejectWithValue(
          res.response?.data || { error: "Ошибка при выполнении действия" }
        )
      );
  }
);

export const reducerSubscriptionAction = {
  [subscriptionAction.pending]: (state) => {
    state.subscriptionAction.loading = true;
    state.subscriptionAction.error = null;
  },
  [subscriptionAction.fulfilled]: (state, action) => {
    state.subscriptionAction.loading = false;
    state.subscriptionAction.data = action.payload;
    state.subscriptionAction.error = null;
  },
  [subscriptionAction.rejected]: (state, action) => {
    state.subscriptionAction.loading = false;
    state.subscriptionAction.error = action.payload;
  },
};
